import React from 'react';
import { UserAuthStateForm } from './UserAuthStateForm';
import { AuthFormType, UserIdType, } from './types';
import { useRegistration, useLoginWithOptions } from './hooks';
export const UserAuthStateContainer = ({ authFormType, onCompleted, loginFormTitle, loginFormProductTitle, userIdType = UserIdType.UserID, signinOrRegisterLink = '', forgotPasswordLink = '', cognitoUserPoolConfig = undefined, browserCacheType = 'localStorage', }) => {
    const { handleInputChange, onSubmit, formFields, LinkComponent, ForgotPasswordComponent, authError, buttonLabel, isFetching, } = authFormType === AuthFormType.Registration
        ? // eslint-disable-next-line react-hooks/rules-of-hooks
            useRegistration({
                password: '',
                confirmPassword: '',
                email: '',
                fullName: '',
                phone: '',
            }, onCompleted, signinOrRegisterLink, cognitoUserPoolConfig)
        : // eslint-disable-next-line react-hooks/rules-of-hooks
            useLoginWithOptions({
                defaultInput: {
                    email: '',
                    password: '',
                },
                onCompleted,
                signinOrRegisterLink,
                forgotPasswordLink,
                cognitoUserPoolConfig,
                userIdType,
                browserCacheType,
            });
    return (React.createElement(UserAuthStateForm, { fields: formFields, buttonLabel: buttonLabel, onSubmit: onSubmit, handleInputChange: handleInputChange, title: loginFormTitle, productTitle: loginFormProductTitle, signInOrRegisterLinkComponent: LinkComponent, ForgotPasswordComponent: ForgotPasswordComponent, authError: authError, disabled: isFetching }));
};
//# sourceMappingURL=UserAuthStateContainer.js.map